import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

//import NoMatch from '../components/routing/NoMatch';
import PrivateRoute from '../components/routing/PrivateRoute';

import Dashboard from '../components/dashboard/dashboard';
import OfferListContainer from '../components/offer/list/OfferListContainer';
import SimulatorContainer from 'features/simulator/components/SimulatorContainer';
import OfferWizardRouteContainer from '../components/offer/edit/OfferWizardRouteContainer';
import SettingsContainer from '../components/settings/SettingsContainer';
import UserContainer from '../components/user/UserContainer';
import NotFound from '../components/common/NotFound';
import HeaderPortal from '../components/layout/HeaderPortal';
import ReportsRoute from '../components/reports/ReportsRoute';
import ReportRoute from '../components/reports/ReportRoute';
import DocumentScoringSessionHistoryContainer from 'features/document/edit/scoringHistory/components/DocumentScoringSessionHistoryContainer';
import FolderListContainer from 'features/folder/list/components/FolderListContainer';
import FolderWizardRouteContainer from 'features/folder/wizard/components/FolderWizardRouteContainer';
import FacilityListRouteContainer from 'features/facility/list/components/FacilityListRouteContainer';
import FacilityWizardRouteContainer from 'features/facility/wizard/components/FacilityWizardRouteContainer';
import ResponsibleChangeOfferListContainer from '../features/offer/edit/responsibleChange/components/ResponsibleChangeOfferListContainer';
import BulkPrintingContainer from '../features/offer/edit/bulkPrinting/components/BulkPrintingListContainer';
import FolderAllocateResponsibleContainer from '../features/folder/edit/allocateResponsible/components/FolderAllocateResponsibleContainer';
import MyFeatureContainer from 'featuresGql/newFeature/components/MyFeatureContainer';
import LogRouteStepper from 'features/logs/components/LogRouteStepper';
import PartnerFileListContainer from 'features/partnerFile/list/components/PartnerFileListContainer';
import PartnerFileWizardRouteContainer from 'features/partnerFile/wizard/components/PartnerFileWizardRouteContainer';

const Inbox = () => (
  <div>
    <h2>TODO</h2>
    <HeaderPortal />
  </div>
);

export default (
  <Switch>
    <PrivateRoute exact path='/test' component={MyFeatureContainer} />
    <PrivateRoute exact path='/dashboard' component={Dashboard} />
    <PrivateRoute exact path='/offers' component={OfferListContainer} />
    <PrivateRoute path='/simulator' component={SimulatorContainer} />
    <PrivateRoute exact path='/offers/:newOffer(new)' component={OfferWizardRouteContainer} />
    <PrivateRoute exact path='/offers/:newRestructuring(restructuring)/new' component={OfferWizardRouteContainer} />
    <PrivateRoute exact path='/offers/:newFacilityFrame(facilityFrame)/new' component={OfferWizardRouteContainer} />
    <PrivateRoute path='/offers/:documentId(\d+)/:siteId(\d+)' component={OfferWizardRouteContainer} />
    <PrivateRoute
      path='/offers/:documentId(\d+)/:siteId(\d+)/documentHistory/:fileId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})'
      component={OfferWizardRouteContainer}
    />
    <PrivateRoute
      exact
      path='/offers/:documentId(\d+)/:siteId(\d+)/:sessionID([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/historyscoringsession'
      component={DocumentScoringSessionHistoryContainer}
    />
    <PrivateRoute exact path='/offers/bulkPrint' component={BulkPrintingContainer} />
    <PrivateRoute exact path='/offers/responsibleChange' component={ResponsibleChangeOfferListContainer} />
    <Route path='/offers/:notFound' render={() => <NotFound title='OfferNotFound'></NotFound>} />
    <PrivateRoute exact path='/applications' component={Inbox} />
    <PrivateRoute exact path='/reports' component={ReportsRoute} />
    <PrivateRoute exact path='/reports/:reportId(\d+)' component={ReportRoute} />
    <PrivateRoute exact path='/folders' component={FolderListContainer} />
    <PrivateRoute exact path='/folders/:newFolder(new)' component={FolderWizardRouteContainer} />
    <PrivateRoute exact path='/folders/:newFacilityApproval(facilityApproval)/new' component={FolderWizardRouteContainer} />
    <PrivateRoute path='/folders/:documentId(\d+)/:siteId(\d+)' component={FolderWizardRouteContainer} />
    <PrivateRoute exact path='/facilities' component={FacilityListRouteContainer} />
    <PrivateRoute exact path='/facilities/:newFacility(new)' component={FacilityWizardRouteContainer} />
    <PrivateRoute path='/facilities/:documentId(\d+)/:siteId(\d+)' component={FacilityWizardRouteContainer} />
    <PrivateRoute exact path='/folders/responsibleChange' component={FolderAllocateResponsibleContainer} />
    <PrivateRoute exact path='/settings' component={SettingsContainer} />
    <PrivateRoute exact path='/user' component={UserContainer} />
    <PrivateRoute exact path='/logs' component={() => <Redirect to={{ pathname: '/logs/systemLogs' }} replace />} />
    <PrivateRoute exact path='/logs/systemLogs' component={LogRouteStepper} />
    <PrivateRoute exact path='/logs/systemLogs/logDetail/:id' component={LogRouteStepper} />
    <PrivateRoute exact path='/logs/systemLogs/:correlationId' component={LogRouteStepper} />
    <PrivateRoute exact path='/logs/genericFilterParamLogs' component={LogRouteStepper} />
    <PrivateRoute exact path='/logs/evaluationLogs' component={LogRouteStepper} />
    <PrivateRoute exact path='/partner-files' component={PartnerFileListContainer} />
    <PrivateRoute exact path='/partner-files/:newPartnerFile(new)' component={PartnerFileWizardRouteContainer} />
    <PrivateRoute exact path='/partner-files/:newBulkFile(new-bulk)' component={PartnerFileWizardRouteContainer} />
    <PrivateRoute path='/partner-files/:documentId(\d+)/:siteId(\d+)' component={PartnerFileWizardRouteContainer} />
    <Route path='/notAllowed' render={() => <NotFound title='NotAllowed'></NotFound>} />
    <Redirect exact from='/' to='/dashboard' />
    <Route render={() => <NotFound title='PageNotFound'></NotFound>} />
  </Switch>
);
